"use client";

import {
  ReactNode,
  createContext,
  useContext,
  useState,
} from "react";

import { ContextValue } from "@/types/context";

const AppContext = createContext({} as ContextValue);

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  const [showSignModal, setShowSignModal] = useState<boolean>(false);
  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  return (
    <AppContext.Provider
      value={{
        showSignModal,
        setShowSignModal,
        showFeedback,
        setShowFeedback,
        // stub: legacy components may call setUser but it's a no-op now
        user: null,
        setUser: () => {},
        fetchUserInfoFromBackend: async () => null,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
